import Dialog from '@utils/common/dialog'
import supplierTable from './components/supplierTable.vue'
import supplierTableSingle from './components/supplierTableSingle.vue'
import supplierSearchTable from './components/supplierSearchTable.vue'
import itemTable from './components/itemTable.vue'
import itemTableSingle from './components/itemTableSingle.vue'
import itemTypeTable from './components/itemTypeTable.vue'
import supplierTypeTable from './components/supplierTypeTable.vue'

/**
 *  Input 文件夹 高级搜索多选 (供应商,物料,物料类别)
 *  formInput 文件夹 表单单选 (供应商)
*/

// 选择供应商 (新增、编辑) 多选
const supplierDialog = new Dialog('commonDialog')
  .title('selectSupplier')
  .dialog({ width: '65%' })
  .component(supplierTable)
  .validate(async(vm) => {
    return await vm.validate()
  })

// 选择供应商 (高级搜索) 多选
const supplierSearchDialog = new Dialog('commonDialog')
  .title('selectSupplier')
  .dialog({ width: '65%' })
  .component(supplierSearchTable)
  .validate(async(vm) => {
    return await vm.validate()
  })

// 选择供应商 (新增、编辑) 单选
const supplierDialogSingle = new Dialog('commonDialog')
  .title('selectSupplier')
  .dialog({ width: '65%' })
  .component(supplierTableSingle)
  .validate(async(vm) => {
    return await vm.validate()
  })

// 选择物料 (新增、编辑、高级搜索) 多选
const itemDialog = new Dialog('commonDialog')
  .title('selectGoodsDialog')
  .dialog({ width: '65%' })
  .component(itemTable)
  .validate(async(vm) => {
    return await vm.validate()
  })

// 选择物料 (新增、编辑、高级搜索) 单选
const itemDialogSingle = new Dialog('commonDialog')
  .title('selectGoodsDialog')
  .dialog({ width: '65%' })
  .component(itemTableSingle)
  .validate(async(vm) => {
    return await vm.validate()
  })

// 物料类别 多选
const itemTypeDialog = new Dialog('commonDialog')
  .title('chooseType')
  .dialog({ width: '50%' })
  .component(itemTypeTable)
  .validate(async(vm) => {
    return await vm.validate()
  })

// 供应商类别 多选
const supplierTypeDialog = new Dialog('commonDialog')
  .title('chooseSupplierType')
  .dialog({ width: '50%' })
  .component(supplierTypeTable)
  .validate(async(vm) => {
    return await vm.validate()
  })

export {
  supplierDialog,
  supplierSearchDialog,
  itemDialog,
  itemDialogSingle,
  supplierDialogSingle,
  itemTypeDialog,
  supplierTypeDialog
}
